<template>
    <app-wrapper>
        <transition appear name="fadeout">
            <v-card class="pa-2">
                <v-img class="mt-4" contain>
                    <img width="150" height="57" src="../assets/qg-logo_trans-1a.png">
                </v-img>
                <v-card-title primary-title>
                    <div v-if="isWelcome">
                        <h4 class="subheading">
                            WELCOME
                        </h4>
                    </div>
                    <div v-else-if="isExpired">
                        <h4 class="subheading">
                            UPDATE EXPIRED PASSWORD
                        </h4>
                    </div>
                    <div v-else>
                        <h4 class="subheading">
                            RESET PASSWORD
                        </h4>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-alert outlined type="error" dismissible v-model="showerr">
                        {{ errmsg }}
                    </v-alert>
                    <v-alert outlined type="success" dismissible v-model="showsent">
                        A confirmation was code sent to your email.
                    </v-alert>
                    <div v-if="!codesent">
                        <h4 class="subheading" v-if="isWelcome">
                            Please enter your email and we'll lookup your account, then send you a code used to set your initial password.
                        </h4>
                        <h4 class="subheading" v-else-if="isExpired">
                            Your password has expired, we will send you a code used to update your password.
                        </h4>
                        <h4 class="subheading" v-else-if="isAuthenticated">
                            This is the email address associated with your account, we will send you a code used to reset your password.
                        </h4>
                        <h4 class="subheading" v-else>
                            Please enter your email and we'll lookup your account, then send you a code used to reset your password.
                        </h4>
                        <v-form v-model="validemail">
                            <!-- can't get enter to work here, seems to need form with more than one field  @keyup.native.enter="validemail && onFind()" -->
                            <v-text-field
                                label="Enter E-mail"
                                v-model="username"
                                :rules="emailRules"
                                required clearable
                                :disabled="isAuthenticated" />
                        </v-form>
                        <v-btn
                            block
                            :loading="loading"
                            @click.native="onFind()"
                            :disabled="!validemail"
                            color="submit">
                            Find
                            <span slot="loader">Verifying account...</span>
                        </v-btn>
                        <div>
                            <br>A confirmation code will be sent to your email address.
                        </div>
                    </div>
                    <div v-if="codesent">
                        <h4 class="subheading">
                            Confirm password change
                        </h4>
                        <v-form v-model="validcode">
                            <!-- can't get enter to work here, seems to need form with more than one field  @keyup.native.enter="validcode && onSubmit()" -->
                            <v-text-field
                                label="Confirmation Code"
                                v-model="code"
                                :rules="codeRules"
                                required clearable />
                            <v-text-field
                                autocomplete="new-password"
                                label="New Password"
                                v-model="password"
                                :rules="passRules"
                                :append-icon="hidepw ? 'visibility' : 'visibility_off'"
                                @click:append="() => (hidepw = !hidepw)"
                                :type="hidepw ? 'password' : 'text'"
                                required />
                        </v-form>
                        <v-btn
                            block
                            :loading="loading"
                            @click.native="onSubmit()"
                            :disabled="!validcode"
                            color="submit">
                            Confirm
                            <span slot="loader">Updating password...</span>
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </transition>
    <!-- <app-terms></app-terms> -->
    </app-wrapper>
</template>

<script>
import wrapper from "./wrapper"
import terms from "./terms"
import router from "../router"
import config from "../config"
import axios from "axios"
var AmazonCognitoIdentity = require("amazon-cognito-identity-js")
var user_pool = []

export default {
    components: {
        "app-wrapper": wrapper,
        "app-terms": terms,
    },
    data: function() 
    {
        return {
            codesent: false,
            callback: false,
            showerr: false,
            showsent: false,
            errmsg: "",
            validemail: false,
            validcode: false,
            username: "",
            emailRules: [(v) => !!v || "E-mail is required",
                (v) => !/branch\d+@jci.com/gi.test(v) || "Detected a shared branch email addresses, password reset not available, please contact QGistix support to reset your password",
                // eslint-disable-next-line
        (v) => /^.+\@.+\..+$/.test(v) || 'E-mail must be valid'],
            password: "",
            passRules: [(v) => !!v || "Password is required",
                (v) => !v || v.length >= 8 || "Password must be 8-20 characters",
                // (v) => /^(?=.*[0-9])/.test(v) || 'Password must contain at least 1 number',
                // (v) => /^(?=.*[a-z])/.test(v) || 'Password must contain at least 1 lower case letter',
                // (v) => /^(?=.*[A-Z])/.test(v) || 'Password must contain at least 1 upper case letter',
                // (v) => /^(?=.*[!@#$%^&*"])/.test(v) || 'Password must contain at least 1 special character (!@#$%^&*")'
            ],
            code: "",
            codeRules: [(v) => !!v || "Code is required"],
            hidepw: true,
            loader: false,
            loading: false,
        }
    },
    computed: {
        isAuthenticated() 
        {
            return this.$store.state.auth.isAuthenticated;
        },
        isWelcome() 
        {
            return this.$route.path == "/welcome"
        },
        isPwdChange() 
        {
            return this.$route.path == "/pwdchange"
        },
        isExpired() 
        {
            return this.$route.path == "/expired"
        },
    },
    methods: {
        async onSubmit() 
        {
            this.loader = "loading"
            const l = this.loader
            this[l] = !this[l]

            user_pool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData)
            var user_data = {
                Username: this.username.toLowerCase(),
                Pool: user_pool,
            }
            console.log("password change for " + user_data.Username)
            var cognito_user = new AmazonCognitoIdentity.CognitoUser(user_data)
            this.showsent = false
            this.errmsg = ""

            try
            {
                let result = await axios.patch(config.QUS + "portal/user/" + encodeURIComponent(this.username.toLowerCase()) + "/confirmforgot", { code: this.code, pwd: this.password },
                    { headers: { Authorization: this.$store.state.auth.idToken } })
                console.log(JSON.stringify(result.data))

                if (result.data.success)
                {
                    console.log("cognito and qg user record updated with new password")
                    router.push("/changed")
                }
                else
                {
                    console.error(result.data.message)
                    this.errmsg = result.data.message
                }
            }
            catch(err)
            {
                console.error(err)
            }
            finally
            {
                this[l] = false
                this.loader = null
            }
        },
        onFind() 
        {
            this.loader = "loading"
            const l = this.loader
            this[l] = !this[l]

            user_pool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData)
            var user_data = {
                Username: this.username,
                Pool: user_pool,
            }
            console.log("password forgot for " + user_data.Username)
            var cognito_user = new AmazonCognitoIdentity.CognitoUser(user_data)
            this.errmsg = ""

            cognito_user.forgotPassword({
                onSuccess: (data) => 
                {
                    console.log("forgot password initiated: " + JSON.stringify(data))
                    this[l] = false
                    this.loader = null
                },
                onFailure: (err) => 
                {
                    console.error("forgot password error: " + JSON.stringify(err))
                    this.errmsg = err.message
                    this[l] = false
                    this.loader = null
                },
                inputVerificationCode: (data) => 
                {
                    var result = JSON.stringify(data)
                    console.log("Code sent to: " + result)
                    this.codesent = true
                    this.showsent = true
                    this.valid = false
                    this[l] = false
                    this.loader = null
                },
            })
        },
    },
    watch: {
        errmsg() 
        {
            console.log(`watched error message: ${this.errmsg}`)
            if (this.errmsg !== "")
            {
                if (this.errmsg.startsWith("UserMigration failed with error "))
                {
                    this.errmsg = this.errmsg.substr(32)
                }
                this.showerr = true
            }
        },
    },
    created() 
    {
        if ((this.isExpired || this.isPwdChange) && this.isAuthenticated)
        {
            this.username = this.$store.state.auth.profile.email
        }
    },
}
</script>
<style scoped>
</style>
